/**
 * OIDC reducer for Redux
 * 
 * This reducer manages the OIDC authentication state in the Redux store
 * It's compatible with @axa-fr/react-oidc and ensures tokens are available to API services
 */

// Action types
const USER_FOUND = 'oidc/userFound';
const USER_EXPIRED = 'oidc/userExpired';
const USER_SIGNED_OUT = 'oidc/userSignedOut';
const SILENT_RENEW_ERROR = 'oidc/silentRenewError';
const SESSION_TERMINATED = 'oidc/sessionTerminated';
const LOADING_USER = 'oidc/loadingUser';
const USER_LOADED = 'oidc/userLoaded';

// Initial state
const initialState = {
  isAuthenticated: false,
  user: null,
  isLoading: false,
  error: null,
};

// Reducer
const oidcReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_FOUND:
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload,
        isLoading: false,
        error: null,
      };
      
    case LOADING_USER:
      return {
        ...state,
        isLoading: true,
      };
      
    case USER_LOADED:
      return {
        ...state,
        isLoading: false,
      };
      
    case USER_EXPIRED:
    case USER_SIGNED_OUT:
    case SESSION_TERMINATED:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        isLoading: false,
      };
      
    case SILENT_RENEW_ERROR:
      return {
        ...state,
        error: action.payload,
      };
      
    default:
      return state;
  }
};

// Action creators
export const userFound = user => ({
  type: USER_FOUND,
  payload: user,
});

export const userExpired = () => ({
  type: USER_EXPIRED,
});

export const userSignedOut = () => ({
  type: USER_SIGNED_OUT,
});

export const sessionTerminated = () => ({
  type: SESSION_TERMINATED,
});

export const silentRenewError = error => ({
  type: SILENT_RENEW_ERROR,
  payload: error,
});

export const loadingUser = () => ({
  type: LOADING_USER,
});

export const userLoaded = () => ({
  type: USER_LOADED,
});

export default oidcReducer;